import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsTimeslotKind from 'graphql/fields/FieldsTimeslotKind'

const fields = {
	'guid': 'String',
	'name': 'String!',
	'icon': 'String',
	'icon_color': 'String',
	'background_color': 'String',
	'can_overlap_with_booking': 'String',
	'can_only_select_one_per_day': 'String',
	'sub_icon': 'String',
	'secondary_sub_icon': 'String',
	'kind': 'String',
	'sub_kind': 'String',
	'can_book_from': 'String',
	'can_book_until': 'String',
	'can_cancel_until': 'String',
	'can_scan_presence_qr_code': 'String',
	'can_scan_presence_qr_code_from': 'String',
	'can_scan_presence_qr_code_until': 'String',
	'show_capacity': 'String',
	'show_capacity_in_timeslot': 'String',
	'show_time': 'String',
	'extra_parameters': 'String',
	'instructions_link': 'String',
	'credit_amount': 'Int',
	'active': 'String!',
};

export default gql(`
	mutation timeslot_kind( ${ HelperGraphql.createFields( fields ) } ) {
	    timeslot_kind( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsTimeslotKind}
	    }
	}
`);

